import { render, staticRenderFns } from "./CompanyReportsTable.vue?vue&type=template&id=593b8409&scoped=true"
import script from "./CompanyReportsTable.vue?vue&type=script&lang=js"
export * from "./CompanyReportsTable.vue?vue&type=script&lang=js"
import style0 from "./CompanyReportsTable.vue?vue&type=style&index=0&id=593b8409&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593b8409",
  null
  
)

export default component.exports